"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObjectLike;

var _typeof3 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function _typeof(obj) {
  if (typeof Symbol === "function" && (0, _typeof3.default)(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return (0, _typeof3.default)(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : (0, _typeof3.default)(obj);
    };
  }

  return _typeof(obj);
}
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */


function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

module.exports = exports.default;